import { CheckboxProps } from '@chakra-ui/react';
import { CheckmarkIcon } from 'ui-components/dist/CheckmarkIcon';
import { MinusIcon } from 'ui-components/dist/MinusIcon';

const IndeterminateIcon = () => <MinusIcon boxSize={4} />;
const CheckedIcon = () => <CheckmarkIcon boxSize={4} />;

export const getCheckboxIcon = ({
  isChecked,
  isIndeterminate,
}: CheckboxProps) => {
  switch (true) {
    case isIndeterminate:
      return <IndeterminateIcon />;
    case isChecked:
      return <CheckedIcon />;
  }
};
